import { render, staticRenderFns } from "./SectionMatch.vue?vue&type=template&id=9fa060f2&"
import script from "./SectionMatch.vue?vue&type=script&lang=js&"
export * from "./SectionMatch.vue?vue&type=script&lang=js&"
import style0 from "./SectionMatch.vue?vue&type=style&index=0&id=9fa060f2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports